import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ShieldCheck } from 'lucide-react';
import { authApi } from '../api/auth';
import LoadingSpinner from '../components/LoadingSpinner';

function errorText(error: unknown): string {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  return typeof detail === 'string' ? detail : 'This support link could not be used.';
}

export default function SupportLoginPage() {
  const started = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = params.get('token') || '';
    history.replaceState(null, '', '/support-login');
    if (!token) {
      setError('This support link is missing its one-time token.');
      return;
    }
    void authApi.exchangeSupportLogin(token).then(({ data }) => {
      localStorage.setItem('saik_token', data.token);
      localStorage.setItem('saik_user', JSON.stringify(data.user));
      // A support link forces a password reset: never land in the app first.
      window.location.replace(data.user.must_reset_password ? '/reset-password' : '/app/chat');
    }).catch(error => setError(errorText(error)));
  }, []);

  return <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 dark:bg-slate-950">
    <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-xl dark:border-slate-800 dark:bg-slate-900">
      {error ? <>
        <AlertTriangle className="mx-auto text-red-500" size={40} />
        <h1 className="mt-4 text-xl font-semibold text-slate-900 dark:text-white">Support link unavailable</h1>
        <p role="alert" className="mt-2 text-sm text-slate-600 dark:text-slate-400">{error}</p>
        <Link to="/login" className="mt-6 inline-block rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white dark:bg-white dark:text-slate-900">Return to login</Link>
      </> : <>
        <ShieldCheck className="mx-auto text-emerald-600" size={40} />
        <h1 className="mt-4 text-xl font-semibold text-slate-900 dark:text-white">Opening secure support session</h1>
        <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">This one-time link is being exchanged and removed.</p>
        <div className="mt-6 flex justify-center"><LoadingSpinner size="lg" /></div>
      </>}
    </div>
  </div>;
}
